import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "./api";

export default function UploadPage() {
  const [files, setFiles] = useState([]);
  const navigate = useNavigate();

  // Logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  // Fetch all uploaded files
  const fetchFiles = async () => {
    try {
      const res = await API.get("/files");
      const fileData = Array.isArray(res.data)
        ? res.data
        : res.data.files || [];
      setFiles(fileData);
    } catch (err) {
      console.error("Error fetching files:", err);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  //  Handle multiple file upload
  const handleUpload = async (e) => {
    const formData = new FormData();
    for (let i = 0; i < e.target.files.length; i++) {
      formData.append("files", e.target.files[i]);
    }

    try {
      const res = await API.post("/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.success) {
        alert("Files uploaded successfully!");
        fetchFiles();
      }
    } catch (err) {
      alert("Upload failed");
      console.error(err);
    }
  };

  return (
    <div
      style={{
        fontFamily: "Inter, sans-serif",
        backgroundColor: "#f4f6fc",
        minHeight: "100vh",
        padding: "30px",
      }}
    >
      {/*  Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#ffffff",
          padding: "15px 25px",
          borderRadius: "10px",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
          marginBottom: "30px",
        }}
      >
        <h2 style={{ margin: 0, color: "#333" }}>📁 File Management</h2>
        <button
          onClick={handleLogout}
          style={{
            backgroundColor: "#e63946",
            color: "white",
            border: "none",
            borderRadius: "6px",
            padding: "8px 15px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Logout
        </button>
      </div>

      {/*  Upload Section */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
          padding: "30px",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <h3 style={{ color: "#2a2a2a" }}>📂 Upload Multiple Files</h3>
        <p style={{ color: "#777" }}>
          Choose files to upload. .
        </p>

        <label
          style={{
            display: "inline-block",
            padding: "12px 25px",
            backgroundColor: "#007bff",
            color: "white",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "500",
            transition: "0.2s",
          }}
        >
          📤 Choose Files
          <input
            type="file"
            multiple
            onChange={handleUpload}
            style={{ display: "none" }}
          />
        </label>
      </div>

      {/*  Uploaded Files Table */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
          padding: "25px",
        }}
      >
        <h4 style={{ marginBottom: "20px", color: "#2a2a2a" }}>📄 Uploaded Files</h4>

        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              textAlign: "left",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f1f3f6" }}>
                <th style={{ padding: "10px" }}>ID</th>
                <th style={{ padding: "10px" }}>Original Name</th>
                <th style={{ padding: "10px" }}>Stored Name</th>
                <th style={{ padding: "10px" }}>Upload Date</th>
                <th style={{ padding: "10px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {files.length === 0 ? (
                <tr>
                  <td colSpan="5" align="center" style={{ padding: "15px" }}>
                    No files uploaded yet 📂
                  </td>
                </tr>
              ) : (
                files.map((f) => (
                  <tr
                    key={f.id}
                    style={{
                      borderBottom: "1px solid #eee",
                      transition: "0.2s",
                    }}
                  >
                    <td style={{ padding: "10px" }}>{f.id}</td>
                    <td style={{ padding: "10px" }}>{f.original_name}</td>
                    <td style={{ padding: "10px" }}>{f.stored_name}</td>
                    <td style={{ padding: "10px" }}>
                      {new Date(f.upload_date).toLocaleString()}
                    </td>
                    <td style={{ padding: "10px" }}>
                      <button
                       onClick={() => navigate(`/AdminDashboard/ViewFilePage/${f.stored_name}`)}
                        style={{
                          backgroundColor: "#17a2b8",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          padding: "6px 12px",
                          cursor: "pointer",
                        }}
                      >
                        👁 View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
